module.exports = __webpack_public_path__ + "static/media/batiste.7b520c63.png";